'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getShouldFetchInitialVisitorThreads = exports.getShouldFetchInitialVisitorThreads = function getShouldFetchInitialVisitorThreads() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isFirstVisitorSession = _ref.isFirstVisitorSession,
      isEmbeddedInProduct = _ref.isEmbeddedInProduct;

  return Boolean(!isFirstVisitorSession || isEmbeddedInProduct);
};